export const Logo = ({ className = "h-16 w-auto" }) => (
  <img src="/logo.jpeg" alt="Sagar Ventures" className={className} />
);
